import superjson from "superjson";

export const useAuthTokenStore = defineStore("authToken", {
  state: () => ({
    accessToken: "",
    refreshToken: "",
  }),
  actions: {
    setAccessToken(token: string) {
      this.accessToken = token;
    },
    setRefreshToken(token: string) {
      this.refreshToken = token;
    },
  },
  persist: {
    storage: import.meta.client ? sessionStorage : undefined,
    serializer: {
      serialize: superjson.stringify,
      deserialize: superjson.parse,
    },
  },
});
